import React from 'react';
import { Link } from 'react-router-dom';
import abl_logo from '../../assets/logo.png'
export default function WelcomePage() {
  return(
    <>
    <header>
          <figure className="logo">
            <img src={abl_logo} alt=""/>
          </figure>
        </header>
    <div className="container">

      <div className="row justify-content-center align-items-center">
        <div className="card" style={{width: '18rem'}}>
          <div className="card-body">
            <h5 className="card-title">Já possuo login no sistema</h5>

            <p className="card-text">Desejo acessar o sistema!</p>

            <Link to="/login">ACESSAR SISTEMA</Link>

          </div>
        </div>
        <div className="card" style={{width: '18rem'}}>
          <div className="card-body">
            <h5 className="card-title">Não possuo login</h5>

            <p className="card-text">Desejo me cadastrar!</p>
            <Link to="/register">QUERO ME CADASTRAR</Link>

          </div>
        </div>
      </div>

    </div>
    </>
  )
}
